import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';

const StepHeaderText = styled(Box)`
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  font-size: 20px;
`;

const StepHeaderWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
`;

const StepHeader = ({ step }) => {
  function stepHeader(s) {
    switch (s) {
      case 0:
        return (
          <StepHeaderText>
            <strong>Step 1:&nbsp;&nbsp;</strong>Tell Us About Your Company
          </StepHeaderText>
        );
      case 1:
        return (
          <StepHeaderText>
            <strong>Step 2 :&nbsp;&nbsp;</strong> Let’s Create Your Profile
          </StepHeaderText>
        );
      case 2:
        return (
          <StepHeaderText>
            <strong>Thank you!</strong>
          </StepHeaderText>
        );
      default:
        return null;
    }
  }

  return (
    <StepHeaderWrapper mt={[0, 0, 0, '12px']} mb={[3, 3, 3, 4]}>
      {stepHeader(step)}
    </StepHeaderWrapper>
  );
};

export default StepHeader;

StepHeader.propTypes = {
  step: PropTypes.number,
};

StepHeader.defaultProps = {
  step: 0,
};
